module.exports = __webpack_public_path__ + "static/media/hand-point-down.c5ead005.svg";